module.exports = __webpack_public_path__ + "static/media/tail-spin.664bdc75.svg";